module.exports = __webpack_public_path__ + "img/a444bb4.jpg";